<template lang="pug">
  .product-invoice
    y-dialog(fill-height fluid v-model="showModal" transition="fade-transition" persistent :max-width="step === 0? '400px': '600px'" scrollable)
      v-card
        v-card-title.px-4
          .h6.textColor--text {{ windowTitle }}
        v-divider.basic300(v-if="step > 0 && step < 4")

        v-card-text.px-4(:style="step === 4? 'max-height:340px' : ''")
          v-window(v-model="step")

            v-window-item(:value="0")
              v-container.px-0
                .p1.primary500--text {{ $t('to_help_setup') }}

            v-window-item(:value="1")
              v-form.mt-3(ref="form")
                .p1.primary500--text {{ $t('first_product') }}

                .product-name.mt-6
                  .label.basic600--text.text-uppercase {{ $t('product_name.label') }}
                  v-text-field.mt-2(v-model='product.name' :placeholder="$t('product_name.placeholder')" outlined dense persistent-hint :rules="rules.not_empty" counter :maxlength="50" background-color="basic200")

                .price
                  .label.basic600--text.text-uppercase {{ $t('price.label') }}
                  v-text-field.mt-2(v-model='product.price' :placeholder="$t('price.placeholder')" outlined dense type="number" :rules="rules.has_quantity" :prefix="$currency.symbol" background-color="basic200")

                .product-image.d-flex
                  .label.basic600--text.text-uppercase.mb-2 {{ $t('product_image.label') }}
                v-card.mb-3(v-if="resizeImageFileUrl" flat)
                  div(align="center")
                    v-img(:src="resizeImageFileUrl" aspect-ratio="1" width="170")
                      template(v-slot:placeholder)
                        v-row(class="fill-height ma-0" align="center" justify="center")
                          v-progress-circular(indeterminate color="grey")
                v-card.mb-3(v-else outlined height="170" :style="`background-color: ${$vuetify.theme.themes[$theme].primaryT08}`")
                  div.fill-height
                    div.d-flex.justify-center.align-end(style="height: 70%")
                      div
                        div.mb-2(align="center")
                          eva-icon(name="image-outline" :fill="$vuetify.theme.themes[$theme].primaryT32" height="38" width="38")
                        div.file-layout.mb-4
                          v-btn.button-AA-tiny(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}") upload
                          input.input-layout(type="file" @change="onFileChange" accept="image/*" style="width: 60px !important")
                    div.d-flex.justify-center.align-end(style="height: 30%")
                      div.mb-4
                        div.c1.basic600--text.text-center {{ $t('max_image_filesize') }}
                        div.c1.basic600--text.text-center {{ $t('recommended_image_size') }}

            v-window-item(:value="2")
              v-container.pb-0(v-if="$route.query.from_stripe_onboard")
                div(v-if="fetchingYezzapaySetting")
                  v-row.fill-height.ma-0(align='center' justify='center')
                    v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
                div(v-else)
                  div(v-if="yezzapaySetupSuccess")
                    .p1.primary500--text Congratulation, you have successfully activated Yezza Pay! 🎉
                    .p1.primary500--text Now your store can accept payment via online banking.
                  div(v-else)
                    .p1.primary500--text Sorry, Yezza Pay activation was unsuccessful.
                    v-btn.primary.my-2(@click="showActivateYZpayDialog = true" small depressed) Retry Now
                    .p1.primary500--text You can also retry later at Setup > Payments menu.
              v-container.pb-0(v-else)
                .p1.primary500--text {{ $t('preffered_payment') }}
                .methods.mt-n4
                  v-radio-group(v-model='payment.online' mandatory)
                    v-radio(:value="true" v-if="$currency.code === 'MYR'")
                      template(v-slot:label)
                        v-col
                          .s1.basic800--text Online payment gateway with Stripe
                          .c1.basic600--text 5 minute setup and start accepting online payment via FPX, Credit/Debit Card and GrabPay.
                    v-radio(:value="false" hide-details dense v-if="Auth('root', 'payment_bank_transfer')")
                      template(v-slot:label)
                        v-col
                          .s1.basic800--text {{ $t('manual_bank_transfer') }}
                          .c1.basic600--text {{ $t('share_bank_info') }}
                .c1.primary400--text {{ $t('share_bank_desc') }}

            v-window-item(:value="5")
              v-form.mt-3(ref="form")
                .p1.primary500--text Almost there!
                .p1.primary500--text.mt-3 Now let’s set your delivery settings to manage shipping and delivery methods by zones.

                div.text-center.my-6
                  v-btn.my-auto.ml-2(color='textColorAccent' small outlined height=24 :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="showAddZoneDialog = true")
                    eva-icon.ml-n2.mt-1(name="plus-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="14" width="14")
                    .button-AA-tiny.textColorAccent--text Add New Zone

                .c1.primary400--text *Click on the NEXT button below if this step is not related to your business.

            v-window-item(:value="3")
              v-container.px-0
                v-row
                  v-col.px-0(cols="12")
                    .p1.primary500--text.pa-3  {{ $t('optional_setup') }}
                    v-card.ma-3(flat outlined)
                      div.mt-2
                        v-layout
                          v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                            eva-icon.ma-auto(name="credit-card-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                          v-col.pa-0.my-auto
                            v-layout.py-4
                              div.my-auto.pr-2
                                .s1.basic800--text {{ $t('online_payment') }}
                          v-col.pa-0.shrink
                            v-layout.fill-height
                              v-btn.my-auto.mr-3(color="info500" dark @click="setupPayment()" depressed height=24 small)
                                .button-AA-tiny.basic100--text.setup-shipping-wt {{ $t('setup') }}
                        v-divider
                        v-layout
                          v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                            eva-icon.ma-auto(name="car-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                          v-col.pa-0.my-auto
                            v-layout.py-4
                              div.my-auto.pr-2
                                .s1.basic800--text {{ $t('shipping_rates') }}
                          v-col.pa-0.shrink
                            v-layout.fill-height
                              v-btn.my-auto.mr-3(color="info500" dark @click="setupShipping()" depressed height=24 small)
                                .button-AA-tiny.basic100--text.setup-shipping-wt {{ $t('setup') }}
                .p1.primary500--text {{ $t('share_storefront') }}
                v-card.mt-8(flat outlined)
                  div.mt-n1
                    v-layout
                      v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                        eva-icon.ma-auto(name="shopping-cart-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                      v-col.pa-0.my-auto
                        v-layout.py-4
                          div.my-auto.pr-2
                            .s1.basic800--text Yezza Store
                      v-col.pa-0.shrink
                        v-layout.fill-height
                          v-btn.my-auto(color="white" text @click="clickEditForm('/admin/yezza-store')" depressed height=24 small)
                            .button-Aa-tiny.primary400--text {{ $t('edit') }}
                          v-btn.my-auto.mr-3(color="info500" @click="viewYezzaStore()" depressed height=24 small :disabled="!storeIsReady")
                            .button-AA-tiny.basic100--text.share-ys {{ $t('share') }}
                    v-layout
                       v-img.ma-2(:src="require('@/assets/yezza_store.png')" width="71px" aspect-ratio="1")
                    v-divider.basic300
                    v-layout
                      v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                        eva-icon.ma-auto(name="clipboard-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                      v-col.pa-0.my-auto
                        v-layout.py-4
                          div.my-auto.pr-2
                            .s1.basic800--text WhatsApp Form
                      v-col.pa-0.shrink
                        v-layout.fill-height
                          v-btn.my-auto(color="white" text @click="clickEditForm('/admin/forms')" depressed height=24 small)
                            .button-Aa-tiny.primary400--text  {{ $t('edit') }}
                          v-btn.my-auto.mr-3(color="info500" dark @click="viewForm()" depressed height=24 small)
                            .button-AA-tiny.basic100--text.share-wf {{ $t('share') }}
                    v-layout
                       v-img.ma-2(:src="require('@/assets/wa_form.png')" width="71px" aspect-ratio="1")

                //- v-row
                  v-col.px-0(cols="12")
                    .p1.primary500--text.pa-3 Optional extra setup:
                    v-card.ma-3(flat outlined)
                      div.mt-2
                        v-layout
                          v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                            eva-icon.ma-auto(name="credit-card-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                          v-col.pa-0.my-auto
                            v-layout.py-4
                              div.my-auto.pr-2
                                .s1.basic800--text Online Payment Gateway
                          v-col.pa-0.shrink
                            v-layout.fill-height
                              v-btn.my-auto.mr-3(color="info500" dark @click="setupPayment()" depressed height=24 small)
                                .button-AA-tiny.basic100--text.setup-shipping-wt Setup
                        v-divider
                        v-layout
                          v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                            eva-icon.ma-auto(name="car-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                          v-col.pa-0.my-auto
                            v-layout.py-4
                              div.my-auto.pr-2
                                .s1.basic800--text Shipping/Delivery rates
                          v-col.pa-0.shrink
                            v-layout.fill-height
                              v-btn.my-auto.mr-3(color="info500" dark @click="setupShipping()" depressed height=24 small)
                                .button-AA-tiny.basic100--text.setup-shipping-wt Setup
                //- v-row
                  v-col.px-0(cols="12")
                    v-card.pa-4(flat)
                      .s1.textColor--text Other useful guides to help you get started:
                      div.mt-2

                        .s2.primary400--text.mt-1 1. Adding product and product variant:
                        a.c1.textColorAccent--text(href="https://guide.yezza.io/eng/stock-inventory-management/" target="_blank" style="text-decoration: none")
                          div(style="line-height: 1.2em;") https://guide.yezza.io/eng/stock-inventory-management/

                        .s2.primary400--text.mt-3 2. Custom domain request:
                        a.c1.textColorAccent--text(href="http://guide.yezza.io/eng/steps-to-apply-custom-domain-updated-21-10/" target="_blank" style="text-decoration: none;")
                          div(style="line-height: 1.2em;") http://guide.yezza.io/eng/steps-to-apply-custom-domain-updated-21-10/

                        .s2.primary400--text.mt-3 3. Setting up your first WhatsApp Form:
                        a.c1.textColorAccent--text(href="http://guide.yezza.io/eng/making-whatsapp-form/" target="_blank" style="text-decoration: none;")
                          div(style="line-height: 1.2em;") http://guide.yezza.io/eng/making-whatsapp-form/

                        .s2.primary400--text.mt-3 4. Basic Yezza Store Setup:
                        a.c1.textColorAccent--text(href="http://guide.yezza.io/eng/setup-yezza-store-2/" target="_blank" style="text-decoration: none;")
                          div(style="line-height: 1.2em;") http://guide.yezza.io/eng/setup-yezza-store-2/

                        .s2.primary400--text.mt-3 5. Advanced Yezza Store Setup:
                        a.c1.textColorAccent--text(href="http://guide.yezza.io/eng/how-to-give-a-facelift-to-yezza-store-new/" target="_blank" style="text-decoration: none;")
                          div(style="line-height: 1.2em;") http://guide.yezza.io/eng/how-to-give-a-facelift-to-yezza-store-new/

        v-card-actions
          v-spacer
          v-btn(v-if="step === 3" @click="finishStep()" color="info500" dark depressed height=32)
            div.basic100--text Finish
          template(v-else)
            //- v-btn(v-if="step < 4" color="white" text @click="skip()" depressed height=32)
              .button-Aa-small.primary400--text Skip walkthrough
            v-btn(color="info500" dark @click="nextStep()" depressed height=32 :loading="isLoading")
              .button-AA-small.basic100--text(v-if="step == 0") {{ $t('start') }}
              .button-Aa-small.basic100--text(v-else) {{ $t('next') }}

    .modals
      update-yezza-pay(v-if="showActivateYZpayDialog" :open.sync="showActivateYZpayDialog" :company="company" @activated="handleActivateGateway")
      update-cash-payment(v-if="showUpdateCashDialog" :open.sync="showUpdateCashDialog" :company="company" @added="handleActivateGateway")
      update-delivery-zone(v-if="showAddZoneDialog" :open.sync="showAddZoneDialog" :company="company" :allowDelete="false" @added="nextStep()")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UpdateYezzaPay from '@/components/dialogs/settings/UpdateYezzaPay.vue'
import UpdateCashPayment from '@/components/dialogs/settings/UpdateCashPayment.vue'
import UpdateDeliveryZone from '@/components/dialogs/settings/UpdateDeliveryZone.vue'
import { resizeImage } from '@/utils'

export default {
  name: 'WalkThroughSetupDialog',
  props: ['open'],
  components: { UpdateYezzaPay, UpdateCashPayment, UpdateDeliveryZone },
  data: (vm) => ({
    step: 0,
    steps: [
      { title: vm.$t('welcome_to_yezza')},
      { title: vm.$t('step_1')},
      { title: vm.$t('step_2')},
      { title: vm.$t('complete_setup')},
      { title: vm.$t('successful_msg')}
    ],
    product: {
      name: null,
      price: null
    },
    payment: {
      online: true
    },
    showActivateYZpayDialog: false,
    showUpdateCashDialog: false,
    showAddZoneDialog: false,
    form: null,
    storeIsReady: false,
    isLoading: false,
    yezzapaySetupSuccess: false,
    fetchingYezzapaySetting: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required']
    },
    resizeImageFileUrl: '',
    resizeImageFile: null
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      lang: 'language/getLanguage'
    }),
    authMember () {
      return this.$store.state.user.member
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    windowTitle () {
      return this.steps[this.step].title
    },
    currentProgress () {
      return Math.ceil((this.step / this.steps.length) * 100)
    }
  },
  created () {
    if (this.$store.state.user.walkThrough) {
      const savedWalkThrough = this.$store.state.user.walkThrough
      this.step = savedWalkThrough.step
      if (savedWalkThrough.form) {
        this.form = savedWalkThrough.form
      }
    }
  },
  mounted () {
    this.createYezzaStore()
    this.handleReturnFromStripeOnboarding()

  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    nextStep () {
      this.$store.commit('user/setWalkThrough', null)
      if (this.step === 1) {
        this.createProduct()
      } else if (this.step === 2) {
        if (this.$route.query.from_stripe_onboard) {
          this.step++
        } else if (this.payment.online) {
          this.showActivateYZpayDialog = true
        } else {
          this.showUpdateCashDialog = true
        }
      } else {
        this.step++
      }
      if (this.step === 4 && !this.storeIsReady) {
        this.createYezzaStore()
      }
    },
    handleActivateGateway () {
      this.step++
      if (this.payment.online) {
        this.axios.patch(`/companies/${this.company.id}/`, { default_payment_gateway: 'yezzapay' })
      }
    },
    viewYezzaStore () {
      window.open(`https://${this.company.slug}.${process.env.VUE_APP_STORE_URL_DOMAIN}/`, '_blank')
    },
    viewForm () {
      window.open(`https://${this.company.slug}.${process.env.VUE_APP_SHORT_URL_DOMAIN}/${this.form.slug}/`, '_blank')
    },
    setupPayment () {
      if (this.$currency.code == 'MYR') {
        this.showActivateYZpayDialog = true
      } else {
        this.showModal = false
        this.$router.push('/admin/settings/payment')
      }
    },
    setupShipping () {
      if (this.$currency.code == 'MYR'|| this.$currency.code == 'IDR') {
        this.showModal = false
        this.$router.push('/admin/settings/shipping-new')
      } else {
        this.showModal = false
        this.$router.push('/admin/settings/shipping-int')
      }
    },
    clickEditForm (path) {
      this.$store.commit('user/setWalkThrough', { step: 0, skipped: true, skippedTs: new Date() })
      this.showModal = false
      this.$router.push(path)
    },
    skip () {
      this.$store.commit('user/setWalkThrough', { step: 0, skipped: true, skippedTs: new Date() })
      this.showModal = false
      // location.href = '/admin/dashboard'
    },
    finishStep () {
      this.showModal = false
      this.$store.commit('user/setWalkThrough', null)
      location.href = '/admin/dashboard'
    },
    createProduct() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      let params = new FormData()
      params.set('company', this.company.id)
      params.set('name', this.product.name)
      params.set('description', `First product of ${this.company.name}`)
      const memberIds = [this.authMember.id]
      if (this.resizeImageFile) {
        params.append('image', this.resizeImageFile)
      }
      memberIds.forEach(mid => {
        params.set('members', mid)
      })
      params.set('price', (parseFloat(this.product.price)).toFixed(this.$currency.exponent).replace('.', ''))
      this.$axios.post(`/products/`, params)
      .then((resp) => {
        this.createForm(resp.data)
      })
      .catch(() => {})
      .catch(() => {
        this.isLoading = false
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
    },
    createForm(product) {
      let params = {
        company : this.company.id,
        status: 'published',
        name : 'Sample form',
        email_enabled : false,
        email_required : false,
        layout : 'list',
        extra_fields : [],
        type: 'whatsapp',
        language: this.lang,
        members: [this.authMember.id],
        products: [product.id]
      }
      this.$axios.post(`/forms/`, params)
      .then((response) => {
        this.step++
        this.form = response.data
        this.$store.commit('user/setWalkThrough', { step: this.step, form: this.form })
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    createYezzaStore() {
      this.$axios.get(`/store/settings/${this.company.slug}/?expand=form`)
        .then(() => {
          this.storeIsReady = true
        })
        .catch(() => {
          let params = {
            company : this.company.id,
            name : `${this.company.slug} - store`,
            email_enabled : false,
            email_required : false,
            layout : 'inquiry',
            extra_fields : [],
            type: 'store'
          }
          this.$axios.post(`/forms/`, params)
          .then((response) => {
            params = {
              company : this.company.id,
              name: '',
              form: response.data.id
            }
            this.$axios.post(`/store/settings/`, params)
              .then(() => {
                this.storeIsReady = true
              }).catch(() => {})
          }).catch(() => {})
        })
    },
    handleReturnFromStripeOnboarding () {
        if (this.$route.query.from_stripe_onboard) {
          this.step = 2
          this.fetchingYezzapaySetting = true
          setTimeout(() => {
            this.$axios.get(`/yezzapays/?company=${this.company.id}`).then((response) => {
              if (response.data.results.length === 0) {
                this.yezzapaySetupSuccess = false
              } else {
                this.yezzapaySetupSuccess = true
              }
            })
            .catch(() => {
              this.yezzapaySetupSuccess = false
            }).finally(() => {
              this.fetchingYezzapaySetting = false
            })
          }, 3000)
        }
    },
    async onFileChange (e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      const resizedImage = await resizeImage(files[0], 'product_image.jpeg')
      this.resizeImageFileUrl = resizedImage.dataURL
      this.resizeImageFile = resizedImage.file
    },
    }
}
</script>

<style lang="scss" scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.file-layout {
  position: relative;
}
.input-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
</style>

<i18n>
{
  "en": {
    "to_help_setup" : "To help you setup your WhatsApp Commerce, complete 2 Simple Steps in this Walkthrough.",
    "first_product" : "This product will be used in your first storefront. Worry not, you can edit or delete this product later.",
    "preffered_payment": "Choose you preffered way of getting paid by customers.",
    "manual_bank_transfer" : "Manual Bank Transfer",
    "share_bank_info" :"Share your bank account number so that customers can pay directly to your bank account.",
    "share_bank_desc" : "*You can change or turn off these payment methods later in Settings.",
    "optional_setup" : "Optional extra setup:",
    "online_payment" : "Online Payment Gateway",
    "shipping_rates" : "Shipping/Delivery rates",
    "share_storefront" : "You are now ready to share your Yezza Store or WhatsApp Form in your Instagram, WhatsApp Group, FB Page or anywhere and start making money.",
    "welcome_to_yezza" : "Welcome to Yezza",
    "step_1" : "Step 1: Create Your First Product",
    "step_2" : "Step 2: Payment methods",
    "complete_setup":"Setup Complete: Start Selling",
    "successful_msg":"Congratulations",

   "product_name": {
      "label": "Product name",
      "placeholder": "Write product name here"
    },
    "price": {
      "label": "Price",
      "placeholder": "0"
    },
    "product_image": {
      "label": "Product image"
    }
  },
  "id": {
    "to_help_setup" : "Untuk membantu kamu menyiapkan WhatsApp Commerce kamu, selesaikan 2 Langkah Mudah ini.",
    "first_product" : "Produk ini akan digunakan di Toko pertama kamu. Jangan khawatir, kamu dapat mengedit atau menghapus produk ini nanti.",
    "preffered_payment": "Pilih cara yang kamu sukai untuk dibayar oleh pelanggan",
    "manual_bank_transfer" : "Transfer Bank Manual",
    "share_bank_info" :"Bagikan nomor akun bank kamu agar pelanggan dapat membayar langsung ke akun bank kamu.",
    "share_bank_desc" : "*Anda dapat mengubah atau menonaktifkan metode pembayaran ini nanti di laman Tetapan.",
    "optional_setup" : "Kelolaan opsional:",
    "online_payment" : "Gerbang Pembayaran Online",
    "shipping_rates" : "Tarif pengiriman",
    "share_storefront" : "Sekarang kamu siap untuk membagikan Toko Yezza atau form WhatsApp kamu di Instagram, Grup WhatsApp, Halaman FB atau di mana saja dan mulai menghasilkan uang.",
    "welcome_to_yezza" : "Selamat Datang ke Yezza",
    "step_1" : "Langkah 1: Buat Produk Pertama",
    "step_2" : "Langkah 2: Metode Pembayaran",
    "complete_setup":"Lengkap: Mulai Menjual",
    "successful_msg":"Bagus Sekali",
    "product_name": {
      "label": "Nama Produk",
      "placeholder": "Tulis nama produk di sini"
    },
    "price": {
      "label": "Harga",
      "placeholder": "0"
    },
    "product_image": {
      "label": "Foto Produk"
    }
  }
}
</i18n>
